var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V6.75C21 7.16421 20.6642 7.5 20.25 7.5C19.8358 7.5 19.5 7.16421 19.5 6.75V4.5H4.5V6.75C4.5 7.16421 4.16421 7.5 3.75 7.5C3.33579 7.5 3 7.16421 3 6.75V3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5H12.75V19.5H11.25V4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.25C8.25 19.8358 8.58579 19.5 9 19.5H15C15.4142 19.5 15.75 19.8358 15.75 20.25C15.75 20.6642 15.4142 21 15 21H9C8.58579 21 8.25 20.6642 8.25 20.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text.4a06876d396bb0b4ea3654475fda3ea1.svg";